import styled from '@emotion/styled';

export const TilesWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    @media screen and (min-width: 1024px) {
        flex-wrap: nowrap;
    }
`;
